export default class CookieHelper {
    public static getCookiePolicy() {
        return this.getCookie("ckp");
    }

    public static isCookiePolicy() {
        return this.getCookie("ckp");
    }

    public static setCookiePolicyType(type) {
        var cookie = this.getCookie("ckp"),
            values = [];

        if (!cookie) {
            values.push("tech");
            values.push(type);
        } else {
            values = cookie.split("|");
            if (values.indexOf(type) === -1) {
                values.push(type);
            }
        }

        this.setCookie("ckp", values.toString(), 365);
    }

    public static removeCookiePolicyType(type) {
        var cookie = this.getCookie("ckp");
        if (cookie) {
            var values = cookie.split("|");
            var index = values.indexOf(type);
            if (index !== -1) {
                values.splice(index, 1);
            }

            this.setCookie("ckp", values.toString(), 365);
        }
    }

    public static setCookiePolicyAll() {
        var values = ["tech", "stat", "profile"];
        this.setCookie("ckp", values.join("|"), 365);
    }

    public static removeCookiePolicyAll() {
        var values = ["tech"];
        this.setCookie("ckp", values.join("|"), 365);
    }

    public static getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    public static setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    public static deleteCookie(name) {
        document.cookie = name + '=; Max-Age=-99999999;';
    }
}